import merge from 'lodash/merge';
import throttle from 'lodash/throttle';
import { type AppState, LoadingState } from 'store/state';
import { logger } from './logger';

const LOCAL_STORAGE_KEY = 'ARION_NAMESPACE';

export const jsonSafeParse = <T>(value: string): T | null => {
	try {
		return JSON.parse(value) as T;
	} catch (error) {
		logger('Failed to parse data:', error);
		return null;
	}
};

export const saveState = throttle((state: AppState) => {
	try {
		const persistedState = {
			...state,
			riskq: [],
			loading: LoadingState(0)
		};
		globalThis.localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(persistedState));
	} catch (error) {
		logger('Unable to save app state to localStorage:', error);
	}
}, 1000);

export function loadState(defaultState: AppState): AppState {
	try {
		const rawState = globalThis.localStorage.getItem(LOCAL_STORAGE_KEY);
		if (!rawState) {
			return defaultState;
		}

		const parsedState = jsonSafeParse<Partial<AppState>>(rawState);
		if (!parsedState) {
			saveState(defaultState);
			return defaultState;
		}

		return merge({}, defaultState, {
			...parsedState,
			riskq: []
		});
	} catch (error) {
		logger('Unable to load app state from localStorage:', error);
		return defaultState;
	}
}
